import type { FC } from "react";
import { Tooltip } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import classNames from "classnames";
import { isAndroidWebView } from "../../util/androidWebView";
import styles from "./styles.module.scss";

const SHOW_DESKTOP_PREVIEW = true;

interface IAndroidRefreshButtonProps {
  eventName: string;
  className?: string;
  onTrackEvent?: (eventName: string, extra?: Record<string, any>) => void;
}

export const AndroidRefreshButton: FC<IAndroidRefreshButtonProps> = ({
  eventName,
  className,
  onTrackEvent,
}) => {
  if (!SHOW_DESKTOP_PREVIEW && !isAndroidWebView()) return null;

  return (
    <Tooltip title="Refresh page">
      <button
        type="button"
        className={classNames(styles.androidRefreshButton, className)}
        onClick={() => {
          onTrackEvent?.(eventName);
          window.location.reload();
        }}
        aria-label="Refresh page"
      >
        <ReloadOutlined />
        <span>Refresh</span>
      </button>
    </Tooltip>
  );
};
